export enum ChangesNotification {
  LAYOVER_SHORTER = 'layoverShorter',
  LAYOVER_LONGER = 'layoverLonger',
  BOUND_EARLIER = 'boundEarlier',
  BOUND_LATER = 'boundLater',
}
